module.exports = __webpack_public_path__ + "img/dpsy-icon-fg.b2d7341a.png";